import { createFileRoute } from "@tanstack/react-router";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";

const SITE_URL = "https://letslistbusiness.com";

const SECTIONS = [
  { id: "use", title: "Use of the service", body: "You agree to use LetsListBusiness lawfully and not to upload abusive, fraudulent, or infringing content. We may remove content or suspend accounts at our discretion." },
  { id: "content", title: "User content", body: "You retain ownership of content you post but grant us a worldwide license to display and distribute it on the service." },
  { id: "listings", title: "Listings", body: "Business information is provided as-is. We are not responsible for the accuracy of third-party listings." },
  { id: "liability", title: "Limitation of liability", body: "LetsListBusiness is provided without warranties. To the maximum extent permitted by law, we are not liable for indirect or consequential damages." },
  { id: "contact", title: "Contact", body: "Questions about these terms? Email legal@letslistbusiness.com." },
];

export const Route = createFileRoute("/terms/")({
  head: () => {
    const title = "Terms of Service | LetsListBusiness";
    const description = "Read our terms of service to understand the rules and guidelines for using the LetsListBusiness platform.";
    const url = SITE_URL + "/terms/";
    
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: "Terms of Service" },
      ],
      links: [{ rel: "canonical", href: url }],
      schema: [
        generateWebPageSchema(title, description, url),
        generateBreadcrumbSchema([
          { label: "Home", href: "/" },
          { label: "Terms", href: "/terms/" },
        ], SITE_URL),
      ],
    };
  },
  component: TermsPage,
});

function TermsPage() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Terms" }]} />

      <section className="container mx-auto px-4 pb-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <aside className="lg:col-span-3">
            <div className="sticky top-24">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">On this page</div>
              <nav className="mt-4 space-y-1 border-l border-border">
                {SECTIONS.map((s, i) => (
                  <a key={s.id} href={`#${s.id}`} className="block border-l-2 border-transparent py-1.5 pl-4 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-primary">
                    <span className="mr-2 font-mono text-[10px]">{String(i + 1).padStart(2, "0")}</span>
                    {s.title}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          <article className="lg:col-span-9">
            <div className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">Legal</div>
            <h1 className="mt-3 font-display text-5xl font-bold">Terms of Service</h1>
            <p className="mt-3 text-sm text-muted-foreground">Last updated: January 2025</p>

            <p className="mt-8 text-lg leading-relaxed text-foreground/85">
              By accessing LetsListBusiness, you agree to these terms. If you do not
              agree, do not use the service.
            </p>

            <div className="mt-12 space-y-12">
              {SECTIONS.map((s, i) => (
                <section key={s.id} id={s.id} className="scroll-mt-24">
                  <div className="flex items-baseline gap-4">
                    <span className="font-mono text-sm text-primary">{String(i + 1).padStart(2, "0")}</span>
                    <h2 className="font-display text-2xl font-bold">{s.title}</h2>
                  </div>
                  <p className="mt-4 text-base leading-relaxed text-muted-foreground">{s.body}</p>
                </section>
              ))}
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
